// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__36bBO","icon":"SortAdornment_icon__1Kz_8","up":"SortAdornment_up__2DYYI","down":"SortAdornment_down__j8WZr","active":"SortAdornment_active__fV5qJ"};